<template>
  <div id="app">
    <div class="search">
      <div>
        <el-input
          v-model="searchVal.name"
          placeholder="姓名查询"
          style="width:210px;height:34px;"
          @keyup.enter.native="query"
        ></el-input>
      </div>
      <div>
        <el-input
          v-model="searchVal.phone"
          placeholder="手机号查询"
          style="width:210px;height:34px;"
          @keyup.enter.native="query"
        ></el-input>
      </div>
      <div>
        <el-input
          v-model="searchVal.position_name"
          placeholder="职位名称查询"
          style="width:210px;height:34px;"
          @keyup.enter.native="query"
        ></el-input>
      </div>
      <div class="date">
        <el-date-picker
          type="date"
          placeholder="年/月/日"
          v-model="start_ctime"
          value-format="timestamp"
          style="width: 152px;"
        ></el-date-picker>
        <span></span>
        <el-date-picker
          type="date"
          placeholder="年/月/日"
          v-model="end_ctime"
          value-format="timestamp"
          style="width: 152px;"
        ></el-date-picker>
      </div>
      <div class="select">
        <el-select v-model="searchVal.educ_list" placeholder="学历要求">
          <el-option
            v-for="item in prem.educations"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="select">
        <el-select v-model="searchVal.years" placeholder="工作经验">
          <el-option
            v-for="item in prem.years"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="select">
        <el-select v-model="searchVal.salary" placeholder="薪资要求">
          <el-option
            v-for="item in prem.salary"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="select">
        <el-cascader
          placeholder="所在城市"
          v-model="searchVal.map_code"
          :options="prem.citys"
          :props="{
            expandTrigger: 'hover',
            value: 'code',
            label: 'name',
            children: 'cities'
          }"
          @change="cityChange"
        ></el-cascader>
      </div>
      <div class="select">
        <el-select v-model="searchVal.status" placeholder="简历状态">
          <el-option
            v-for="item in prem.deliver_status"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="en_btn">
        <div>
          <el-button
            style="width:90px;padding:10px; height:34px; background:#0077ff; color:#fff;  "
            @click.native.prevent="query"
            >查询</el-button
          >
          <el-button
            style="width:60px;padding:10px;margin-right:15px; height:34px;"
            v-on:click="reset"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <div class="resume">
      <div class="btn-boxs">
        <el-checkbox
          v-model="checked"
          style="color:#888888;"
          @change="toggleAllSelect"
          >本页全选</el-checkbox
        >
        <button class="online" @click="exportResume('1')">导出在线简历</button>
        <button class="annex" @click="exportResume('2')">导出附件简历</button>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, i) in viewChild"
          :key="i"
          class="resume-pane"
          :identify="item.identify"
          :tagid="item.id"
          :label="item.name != '全部' ? item.name + '简历' : item.name"
        >
          <template>
            <TablePage
              ref="multipleTable"
              :isVisited="true"
              :data="deliverList"
              :columns="deliverColumns"
              :page="pages"
              @pageChange="deliverPageChange"
              @putDownID="getPutDownID"
            >
            </TablePage>
          </template>
        </el-tab-pane>
        <!-- <el-tab-pane class="resume-pane" label="下载的简历" name="0">
          <template>
            <TablePage
              :data="downloadList"
              :columns="downloadColumns"
              :page="downloadPage"
              @pageChange="downloadPageChange"
            ></TablePage>
          </template>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import $api from "@/api/ResumeModule";
import TablePage from "@/components/TablePage";
import $Apipublic from "@/api/PublicModule";
import { formatDate } from "@/assets/js/public";
export default {
  components: { TablePage },
  data() {
    return {
      checked: false,
      tagVal: {
        name: "",
        $attrs: {
          identify: "",
          tagid: 0
        }
      },
      isdialog: {
        show: false,
        title: "",
        text: "",
        img: ""
      },
      prem: {},

      activeName: "",
      start_ctime: null,
      end_ctime: null,
      searchVal: {
        name: "",
        phone: "",
        position_name: "",
        educ_list: "",
        years: "",
        salary: "",
        map_code: "",
        status: ""
      },
      deliverColumns: [
        {
          width: 50,
          type: "selection"
        },
        {
          prop: "avatar",
          width: 300,
          align: "center",
          render: (h, scope) => {
            // 1 校招 2实习  3 社招 4双选会 5宣讲会
            return (
              <div style="display: flex;align-items: center;">
                <div style="position: relative;height: 85px;display: flex;flex-direction: column;justify-content: space-between;align-items: center;">
                  <img
                    style="display:flex;justify-content:center;align-items:center;width: 56px; height: 56px; border-radius: 28px;"
                    src={scope.row.avatar}
                    onerror={scope.row.defaultimg}
                  />
                  <img
                    style="position: absolute;right: 0;top: 0;"
                    src={scope.row.sex}
                  />
                  <span style="line-height: 19px;height: 19px;background: #0077FF;border-radius: 11px; font-size:12px; color:#fff;padding:0 10px;">
                    {scope.row.wish_salary_name}
                  </span>
                </div>
                <div style="flex:1;height: 78px;margin-left:20px;display: flex;flex-direction: column;justify-content: space-between;align-items: start;">
                  <p>
                    <span style="width:145px;padding-right:55px; text-align:left;font-size: 16px;font-family: MicrosoftYaHeiSemibold;color: #333333; position:relative;overflow:hidden;text-overflow:ellipsis;white-space: normal;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;">
                      {scope.row.name}
                      <div
                        style={
                          scope.row.is_view == false
                            ? "display:block;width: 8px;height: 8px; border-radius:50%; background: #FF3F1D; position:absolute; top:0px; right:-8px;"
                            : "display:none;width: 8px;height: 8px; border-radius:50%; background: #FF3F1D; position:absolute; top:0px; right:-8px;"
                        }
                      ></div>
                      <span
                        class="bgType brisk-color"
                        style={
                          scope.row.active_name == "本周活跃"
                            ? "border-color: #249E77; color: #249E77;position:absolute; top:0px; right:0;"
                            : scope.row.active_name == "今日活跃"
                            ? "border-color: #FFA825; color: #FFA825;"
                            : scope.row.active_name == "刚刚活跃"
                            ? "border-color: #FF3F1D; color: #FF3F1D;"
                            : "display: none;"
                        }
                      >
                        {scope.row.active_name}
                      </span>
                    </span>
                  </p>
                  <p style="display:flex; font-size: 14px;font-family: MicrosoftYaHei;color: #333333;text-align: left;">
                    {scope.row.phone}
                  </p>
                  <p style="font-size: 12px;font-family: MicrosoftYaHei;color: #666666;text-align: left;overflow:hidden;text-overflow:ellipsis;white-space: normal;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;">
                    <span style="padding-right: 4px;border-right: 1px solid #D5D8DE;">
                      {scope.row.age}岁
                    </span>
                    <span style="padding: 0 4px;border-right: 1px solid #D5D8DE;">
                      {scope.row.educ_name}
                    </span>
                    <span style="padding: 0 4px;border-right: 1px solid #D5D8DE;">
                      {scope.row.job_years}
                    </span>
                    <span
                      style="padding-left: 4px;"
                      title={scope.row.job_status_name}
                    >
                      {scope.row.job_status_name}
                    </span>
                  </p>
                </div>
              </div>
            );
          }
        },
        {
          prop: "name",
          width: 420,
          align: "center",
          render: (h, scope) => {
            return (
              <div style="display: flex;height:78px;font-size: 12px;font-family:MicrosoftYaHei;color: #666666;">
                <div style="border-left: 1px solid #D5D8DE;padding-left: 19px;">
                  <p
                    style={
                      scope.row.pro_start_time && scope.row.pro_end_time
                        ? "display:flex;align-items: center;"
                        : "display:none"
                    }
                  >
                    <img
                      style="width:14px;height:14px;margin-right:12px;"
                      src={scope.row.project_icon}
                    />
                    <span style="font-weight: bold;text-align: left;min-width: 120px;">
                      {scope.row.pro_start_time +
                        " - " +
                        scope.row.pro_end_time}
                    </span>
                    <a
                      style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 1;display: -webkit-box;-webkit-box-orient: vertical;"
                      title={
                        scope.row.project.company +
                        "  " +
                        scope.row.project.position_name
                      }
                    >
                      <span style="text-align: left;">
                        {scope.row.project.company}
                      </span>
                      <span style="margin-left: 10px;text-align: left;">
                        {scope.row.project.position_name}
                      </span>
                    </a>
                  </p>
                  <p
                    style={
                      scope.row.educ_start_time && scope.row.educ_end_time
                        ? "display:flex;align-items: center;"
                        : "display:none"
                    }
                  >
                    <img
                      style="width:14px;height:14px;margin-right:12px;"
                      src={scope.row.educ_icon}
                    />
                    <span style="font-weight: bold;text-align: left;min-width: 120px;">
                      {scope.row.educ_start_time +
                        " - " +
                        scope.row.educ_end_time}
                    </span>
                    <a
                      style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 1;display: -webkit-box;-webkit-box-orient: vertical;"
                      title={
                        scope.row.educ.school + "  " + scope.row.educ.major
                      }
                    >
                      <span style="text-align: left;">
                        {scope.row.educ.school}
                      </span>
                      <span style="margin-left: 10px;text-align: left;">
                        {scope.row.educ.major}
                      </span>
                      <span style="margin-left: 10px;text-align: left;display: none;">
                        {scope.row.educ.educ_name}
                      </span>
                    </a>
                  </p>
                </div>
              </div>
            );
          }
        },
        {
          prop: "id",

          render: (h, scope) => {
            return h(
              "div",
              {
                attrs: {
                  style:
                    "display: flex;justify-content: flex-end;padding-top: 20px;"
                }
              },
              [
                h(
                  "div",
                  {
                    attrs: {
                      style:
                        "font-size: 12px;font-family: MicrosoftYaHeiSemilight;color: #999999;line-height: 16px;display: flex;flex-direction: column;"
                    }
                  },
                  [
                    <span
                      class="bgType"
                      style={
                        scope.row.type_id == 3
                          ? "background: #0077ff; padding: 0 3px;margin-right: 10px;text-align: center;font-size: 12px;color: #fff;"
                          : scope.row.type_id == 1
                          ? "background: #FEAF50; padding: 0 3px;margin-right: 10px;text-align: center;font-size: 12px;color: #fff;"
                          : scope.row.type_id == 2
                          ? "background: #1CD49A; padding: 0 3px;margin-right: 10px;text-align: center;font-size: 12px;color: #fff;"
                          : "background: #00B7FF; padding: 0 3px;margin-right: 10px;text-align: center;font-size: 12px;color: #fff;"
                      }
                    >
                      {scope.row.type}
                    </span>
                  ]
                ),
                h(
                  "div",
                  {
                    attrs: {
                      style:
                        "display: flex;flex: 1;flex-direction: column;align-items: flex-end;justify-content: space-between;"
                    }
                  },
                  [
                    h(
                      "div",
                      {
                        attrs: {
                          style:
                            "font-size: 12px;font-family: MicrosoftYaHeiSemilight;color: #999999;line-height: 16px;display: flex;flex-direction: column;"
                        }
                      },
                      [
                        h(
                          "span",
                          {
                            attrs: {
                              style: ""
                            }
                          },
                          ["投递岗位: " + scope.row.position_name]
                        ),
                        h(
                          "span",
                          {
                            attrs: {
                              style: "margin-top: 9px;"
                            }
                          },
                          [
                            "投递时间: " +
                              this.formatDate(scope.row.delivery_time)
                          ]
                        )
                      ]
                    ),
                    h(
                      "div",
                      {
                        attrs: {
                          style:
                            "margin-top:36px;font-size: 12px;font-family: MicrosoftYaHei;display: flex;"
                        }
                      },
                      [
                        h(
                          "p",
                          {
                            attrs: {
                              style: "color:#249E77;"
                            }
                          },
                          [scope.row.process_status]
                        ),
                        h(
                          "a",
                          {
                            attrs: {
                              style:
                                "color: #333333;cursor: pointer;margin-left: 5px;"
                            },
                            on: {
                              click: () => {
                                this.gotolink(
                                  scope.row.id,
                                  scope.row.created_at,
                                  scope.row.cv_log_id,
                                  scope.row.position_id
                                );
                              }
                            }
                          },
                          ["在线简历>"]
                        )
                      ]
                    )
                  ]
                )
              ]
            );
          }
        }
      ],
      downloadColumns: [
        {
          prop: "avatar",
          width: 55,
          align: "center",
          render: (h, scope) => {
            return (
              <div>
                <img
                  style="display:flex;justify-content:center;align-items:center;width: 36px; height: 36px; border-radius: 18px;"
                  src={scope.row.avatar}
                  onerror={scope.row.defaultimg}
                />
              </div>
            );
          }
        },
        { prop: "name", width: 60, align: "center" },
        { prop: "user_info", width: 370, align: "center" },
        { prop: "project_info", width: 450, align: "center" },
        {
          prop: "id",
          width: 70,
          render: (h, scope) => {
            return h(
              "button",
              {
                class: "table-btn",
                on: {
                  click: () => {
                    this.gotolink(
                      scope.row.id,
                      scope.row.created_at,
                      scope.row.cv_log_id,
                      scope.row.position_id
                    );
                  }
                }
              },
              ["看详情＞"]
            );
          }
        }
      ],
      deliverList: [],
      downloadList: [],
      page_cu: {
        4: {
          current_page: 1,
          per_page: 5
        },
        5: {
          current_page: 1,
          per_page: 5
        }
      },
      downloadPage: {
        current_page: 1,
        per_page: 10
      },
      viewChild: [],
      typeoryears: "type",
      downId: "",
      downParams: {
        ids: "",
        source: "emp",
        cv_type: "",
        admin_id: 1
      },
      email: ""
    };
  },
  computed: {
    pages() {
      return this.page_cu[this.activeName];
    }
  },

  watch: {
    $route(to, from) {
      if (from.name === "ResumeDetailsForList") {
        this.checked = false;
        this.typeoryears = "type";
        this.tagVal.$attrs.tagid = 0;
        this.getDeliverTag();
      }
    }
  },
  created() {
    this.getDeliverTag();
    this.getData();
    const account = JSON.parse(localStorage.getItem("account"));
    const { email } = account;
    this.email = email;
  },
  //激活keep-alive触发
  activated() {
    //激活数据
  },
  deactivated() {
    //销毁
  },
  methods: {
    formatDateMm(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy.MM");
    },
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy.MM.dd h:mm");
    },
    //获取公共数据
    getData() {
      $Apipublic
        .getPublicFormList()
        .then(data => {
          this.prem = { ...this.prem, ...data.data.data };
          console.log(this.prem);
        })
        .catch(err => {
          // console.log("err"+err);
        });
      $Apipublic.getholCitys().then(data => {
        this.prem = { ...this.prem, citys: data.data.provinces };
      });
    },
    getDeliverTag() {
      this.viewChild = [
        {
          id: 4,
          name: "双选会",
          identify: "years"
        },
        {
          id: 5,
          name: "宣讲会",
          identify: "SXH"
        }
      ];
      $api
        .getDeliverTag()
        .then(data => {
          let viewChild = data.data.data;
          let lastView;
          let page_cu = {};
          viewChild.forEach((element, i) => {
            page_cu[element.id] = {
              current_page: 1,
              per_page: 6
            };
          });

          let { is_double } = JSON.parse(localStorage.getItem("account"));
          if (is_double === 1) {
            this.viewChild = [...viewChild, ...this.viewChild];
            this.page_cu = { ...page_cu, ...this.page_cu };
          } else {
            this.viewChild = viewChild;
            this.page_cu = page_cu;
          }
          this.activeName = this.viewChild[0].id.toString();
          console.log(this.viewChild);
          // tag标签选中状态值
          this.tagVal.$attrs.identify = this.viewChild[0].identify;
          this.tagVal.$attrs.identify = this.viewChild[0].id;
          this.handleClick(this.tagVal);
        })
        .catch(err => {
          console.log("getDeliverTag", err);
        });
    },
    //tabs切换
    handleClick(tab) {
      this.checked = false;
      let { identify, tagid } = tab.$attrs;
      this.tagVal.$attrs.identify = identify;
      this.tagVal.$attrs.tagid = tagid;
      this.typeoryears =
        identify === "years" || identify === "SXH" ? "extra_type" : "type";
      this.getDeliverList();
      // name == 0 ? this.getDownloadList() : this.getDeliverList();
    },
    //重置
    reset() {
      this.start_ctime = null;
      this.end_ctime = null;
      let searchData = {
        name: "",
        phone: "",
        position_name: "",

        educ_list: "",
        years: "",
        salary: "",
        map_code: "",
        status: ""
      };
      this.searchVal = { ...searchData };
      this.page_cu[this.activeName].current_page = 1;
      this.tagVal.name = this.activeName;
      this.handleClick(this.tagVal);
    },
    //查询
    query() {
      this.page_cu[this.activeName].current_page = 1;
      this.tagVal.name = this.activeName;
      this.handleClick(this.tagVal);
    },
    //投递的简历get
    getDeliverList() {
      let params = {
        start_ctime: this.start_ctime / 1000,
        end_ctime: this.end_ctime / 1000,
        page: this.page_cu[this.activeName].current_page,
        limit: this.page_cu[this.activeName].per_page,
        [this.typeoryears]: this.tagVal.$attrs.tagid
      };
      params = Object.assign(params, this.searchVal);
      $api
        .getDeliverList(params)
        .then(data => {
          let { list, current_page, last_page, per_page, total } = data.data;
          this.deliverList = list.map(v => {
            return {
              ...v,
              defaultimg: `this.src="${require("@/assets/imgs/hello.png")}"`,
              sex: `${
                v.sex_name === "男"
                  ? require("@/assets/imgs/sex2.png")
                  : require("@/assets/imgs/sex1.png")
              }`,
              educ_start_time: v.educ.id
                ? this.formatDateMm(v.educ.start_time)
                : null,
              educ_end_time: v.educ.id
                ? v.educ.end_time === 1
                  ? "至今"
                  : this.formatDateMm(v.educ.end_time)
                : null,
              pro_start_time: v.project.id
                ? this.formatDateMm(v.project.start_time)
                : null,
              pro_end_time: v.project.id
                ? v.project.end_time === 1
                  ? "至今"
                  : this.formatDateMm(v.project.end_time)
                : null,
              project_icon: require("@/assets/imgs/project-icon.png"),
              educ_icon: require("@/assets/imgs/educ-icon.png")
            };
          });
          this.page_cu[this.activeName] = {
            current_page,
            last_page,
            per_page,
            total
          };
        })
        .catch(err => {
          console.log("getDeliverList", err);
        });
    },
    //下载的简历get
    getDownloadList() {
      let params = {
        page: this.downloadPage.current_page,
        limit: this.downloadPage.per_page,
        name: this.searchVal.name
      };
      $api
        .getDownloadList(params)
        .then(data => {
          // console.log("getDownloadList", data)
          let { list, current_page, last_page, per_page, total } = data.data;
          this.downloadList = list.map(v => {
            return {
              ...v,
              defaultimg: `this.src="${require("@/assets/imgs/hello.png")}"`
            };
          });
          this.downloadPage = { current_page, last_page, per_page, total };
        })
        .catch(err => {
          console.log("getDownloadList", err);
        });
    },
    gotolink(id, created_at, cv_log_id, position_id) {
      // 浏览后的颜色
      // sessionStorage.setItem('historyjob'+created_at,created_at)
      this.$router.push({
        name: "ResumeDetailsForList",
        query: {
          id: id,
          cv_log_id: cv_log_id,
          position_id: position_id
        }
      });
    },

    deliverPageChange(e) {
      this.page_cu[this.activeName].current_page = e;
      this.getDeliverList();
    },
    // downloadPageChange(e) {
    //   this.downloadPage.current_page = e;
    //   this.getDownloadList();
    // },
    //省市分类多级查询
    cityChange(e) {
      this.searchVal.map_code = this.changeArray(e)[
        this.changeArray(e).length - 1
      ];
    },
    //去除0
    changeArray(arr) {
      if (arr) {
        return arr[0] == "0" ? [] : arr;
      }
      return arr;
    },
    //全选
    toggleAllSelect(rows) {
      let parentRef = this.$refs.multipleTable;
      let index = parseInt(this.activeName);
      this.deliverList.map(val => {
        parentRef[index].$refs.upTable.toggleRowSelection(val, rows);
      });
    },

    // 获取多选id
    getPutDownID(id) {
      this.downParams.ids = id.toString();
      this.checked = id.length === this.deliverList.length;
    },
    //type 1导出在线简历简历 ， 2导出附件简历
    exportResume(type) {
      const email = `<span style="color: red;">${this.email}</span>`;
      if (this.downParams.ids == "") {
        this.$message({
          message: "请选择要导出的简历",
          type: "warning"
        });
        return;
      }
      this.downParams.cv_type = type;
      this.isLoading(true, "正在导出简历,请稍后...");
      $api
        .downloadTask(this.downParams)
        .then(data => {
          this.isLoading(false);
          this.$message({
            //
            type: "success",
            dangerouslyUseHTMLString: true,
            message:
              this.downParams.cv_type == "1"
                ? `在线简历导出成功，已发送至${email}，请注意查收！`
                : `附件简历导出成功，已发送至${email}，请注意查收！`
          });
        })
        .catch(err => {
          this.isLoading(false);
          this.$message.error(err.data.error);
        });
    },
    isLoading(show, title) {
      const isloading = this.$loading({
        lock: true,
        text: title,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (show) {
        return isloading;
      } else {
        return isloading.close();
      }
    }
  }
};
</script>
<style scoped>
#app {
  overflow: hidden;
}
/*  */
.search {
  width: 1050px;
  background: #fff;
  border-radius: 5px;
  height: 131px;
  padding: 0 0 20px 30px;
  display: flex;
  display: -ms-flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  flex-direction: row;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  align-items: flex-end;
}
.search > div {
  width: 210px;
  height: 34px;
  margin-right: 15px;
  /* margin-bottom: 20px; */
}
.search div > div {
  display: flex;
  height: 34px;
  align-items: center;
}
.search > div.date {
  width: 343px;
  display: flex;
  align-items: center;
}
.search > div.date span {
  width: 18px;
  border-bottom: 1px solid #e7e7e7;
  height: 1px;
  line-height: 40px;
  margin: 0 11px;
}
.search > div.select {
  width: 150px;
}
.search div span {
  width: 18px;
  font-size: 14px;
  color: #666;
  margin-right: 6px;
}
.search > div.en_btn {
  flex: 1;
}
.search > div.en_btn > div {
  width: 100%;
  display: flex;
  display: -ms-flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  flex-direction: row;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
/*  */
.resume {
  width: 1080px;
  border-radius: 5px;
  background: #fff;
  margin-top: 17px;
  box-sizing: border-box;
  padding: 0 30px;
  position: relative;
}

.resume .resume-pane {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}
.btn-boxs {
  color: #888888;
  position: absolute;
  top: 12px;
  right: 30px;
  z-index: 100;
}
.btn-boxs button {
  width: 120px;
  color: #fff;
  font-size: 12px;
  line-height: 36px;
  background: #0077ff;
  border-radius: 3px;
  margin-left: 5px;
}
.btn-boxs .online {
  margin-left: 20px;
}
.btn-boxs .annex {
  background: #feaf50;
}
/deep/ .brisk-color {
  display: inline-block;
  border-radius: 2px;
  padding: 0 4px;
  margin-left: 20px;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  border: 1px solid;
}
</style>
<style>
.resume .el-tabs__item {
  height: auto;
  color: #888;
  font-size: 16px;
  padding: 20px 15px;
  line-height: normal;
}
.resume .el-tabs__active-bar {
  height: 4px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/resume/resumelist.vue